import * as cx from 'classnames';
import * as React from 'react';
import { LoaderSpinner } from '..';
import * as Styles from './Button.scss';

interface IOwnProps {
  label?: string;
  type: string;
  variant: 'outline' | 'primary' | 'clear';
  size?: 'big' | 'medium' | 'small';
  width?: 'short' | 'long';
  isLoading?: boolean;
  low?: boolean;
  align?: 'center' | 'left' | 'right';
  disabled?: boolean;
  iconOutside?: JSX.Element | null;
  iconInside?: JSX.Element | null;
  iconPosition?: 'left' | 'right';
  onClick?: (event: React.SyntheticEvent<HTMLButtonElement>) => void;
}
const Button: React.SFC<IOwnProps> = (props) => {
  const { label, type, variant, width, disabled, size = 'big', onClick, isLoading, align, iconOutside, iconInside, iconPosition, low } = props;

  const wrapperClassNames = cx({
    [Styles.wrapper]: true,
    [Styles.iconRight]: iconPosition && iconPosition === 'right',
    [Styles.right]: align && align === 'right',
  });

  const buttonClassNames = cx({
    [Styles.button]: true,
    [Styles.outline]: variant === 'outline',
    [Styles.primary]: variant === 'primary',
    [Styles.clear]: variant === 'clear',
    [Styles.small]: size === 'small',
    [Styles.center]: align && align === 'center',
    [Styles.left]: align && align === 'left',
    [Styles.disabled]: disabled || isLoading,
    [Styles.big]: size === 'big',
    [Styles.medium]: size === 'medium',
    [Styles.short]: width === 'short',
    [Styles.long]: width === 'long',
    [Styles.low]: low,
  });

  return (
    <div className={wrapperClassNames}>
      {iconOutside && <div className={Styles.iconOutside}>{iconOutside}</div>}
      <button type={type} className={buttonClassNames} onClick={onClick} disabled={disabled}>
      {!isLoading && <span className={Styles.inner}>
        {iconInside && <span className={Styles.iconInside}>{iconInside}</span>}
        <span>{label}</span>
      </span>}
      {isLoading && <LoaderSpinner />}
    </button>
    </div>
  );
};

export default Button;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/presentational/Button/Button.tsx